/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

const BULK_CATEGORIES = new Set([
  'Fencing',
  'Nutrition',
  'Agriculture chemical',
  'Horticulture chemical',
]);

export const isBulkQuotable = (category: string) => {
  return BULK_CATEGORIES.has(category);
};
